import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TemplateEditorForm from "./template-editor-form";
const TemplateEditor = ({ template, onClose }) => {
    return _jsx(TemplateEditorForm, { onClose: onClose, template: template });
};
export default TemplateEditor;
